import call from "../../../../service/http";
import shareholderConstants from "./shareholderConstants";
import SearchConstants from "../../../search/SearchConstants";

export default {
  namespaced: true,
  state: {
    shareholders: [],
    searchResults: [],
    loadingSearch: false,
  },
  mutations: {
    SET_SHAREHOLDERS: (state, payload) => {
      state.shareholders = payload;
    },
    SET_SEARCH_RESULTS: (state, payload) => {
      state.searchResults = payload;
    },
    SET_LOADING_SEARCH: (state, payload) => {
      state.loadingSearch = payload;
    },
  },
  getters: {
    shareholders: (state) => state.shareholders,
    searchResults: (state) => state.searchResults,
    loadingSearch: (state) => state.loadingSearch,
  },
  actions: {
    searchMembers: ({ commit }, term) => {
      if (!term) {
        commit("SET_SEARCH_RESULTS", []);
        return;
      }
      commit("SET_LOADING_SEARCH", true);
      const query = {
        term: btoa(term.trim()),
        limit: 10,
        select: true,
      };
      call("get", SearchConstants.search(query))
        .then((res) => {
          commit("SET_SEARCH_RESULTS", res.data.data.data);
          commit("SET_LOADING_SEARCH", false);
        })
        .catch(() => {
          commit("SET_LOADING_SEARCH", false);
        });
    },

    getShareholders: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("get", shareholderConstants.shareholders)
        .then((res) => {
          commit("SET_SHAREHOLDERS", res.data.data);
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    addShareholder: ({ commit, dispatch }, data) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", shareholderConstants.shareholders, data)
        .then(() => {
          dispatch("getShareholders");
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    removeShareholder: ({ commit, dispatch }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", shareholderConstants.remove, payload)
        .then(() => {
          dispatch("getShareholders");
          Event.$emit("application-checklist");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },

    updateShareholder: ({ dispatch, commit }, payload) => {
      commit("SET_LOADING", true, { root: true });
      commit("SET_ALERT", null);
      call("post", shareholderConstants.update, payload)
        .then(() => {
          dispatch("getShareholders");
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          commit("SET_ALERT", {
            status: "error",
            message: err.response.data.message,
          });
        });
    },
  },
};
